<template>
  <layout kind="one_column">
    <v-container fluid pt-0 mt-0 pb-0>
      <v-layout row wrap>
        <v-flex xs6 lg9 mb-3>
          <h1 class="max">{{i18n('Global Pix')}}</h1>
        </v-flex>
        <v-flex xs12>

          <div v-bind:class="{'global-pix-box': true, 'disabled': !socketConnected}">
            <div class="box-socket-pending" v-if="!socketConnected">
              <div style="padding: 10px">
                <div style="font-weight: bold;"><v-progress-circular indeterminate :size="15"></v-progress-circular> {{i18n('Aguardando conexão')}} </div>
              </div>
            </div>
          <v-expand-transition >
            <v-card id="transaction-card" class="mb-3" style="border-radius: 10px;">
              <v-container>
                <v-btn :dark="false" class="flex-1" @click="createNewPixTransaction()">
                    <v-icon left dark>add</v-icon>
                    {{ i18n("Novo Pagamento") }}
                  </v-btn>
                <v-divider class="mt-3" />
                <v-layout row wrap>
                  <pix-form
                    v-for="(transaction, index) in transactions"
                    :key="transaction.__ref__"
                    :__ref__="transaction.__ref__"
                    :socketConnected='socketConnected'
                    :prop_transaction_id="transaction.id"
                    :prop_qrcode_string="transaction.qrcode_string"
                    :prop_step="transaction.step"
                    :prop_deposit_value="transaction.deposit_value"
                    :prop_createdAt="transaction.createdAt"
                    :prop_exchanged_value="transaction.exchanged_value"
                    :prop_status="transaction.status"
                    :prop_payment_complete="transaction.payment_complete"
                    :prop_has_error="transaction.has_error"
                    :prop_error_message="transaction.error_message"
                    @onCloseTransaction="onCloseTransaction"
                    @onCreateNewPixTransaction="createNewPixTransaction"
                    @onTransactionUpdated="onTransactionUpdated"
                  />
                </v-layout>
              </v-container>
            </v-card>
          </v-expand-transition>
          </div>

        </v-flex>
      </v-layout>
    </v-container>
  </layout>
</template>

<script>

import LeftBarLayout from "../layouts/LeftBarLayout"
import GlobalPixForm from "../components/GlobalPixForm"
import { v4 as uuidv4 } from 'uuid';

export default {
  name: 'PixPaymentPage',
  components: {
    layout: LeftBarLayout,
    'pix-form': GlobalPixForm
  },
  data() {
    return {
      socketConnected: false,
      company_id: "",
      transactions: []
    }
  },
  computed: {
    partner_id: () => this.store && this.store.company.id
  },
  methods: {
    i18n(str) {
      return this.$root.l(str)
    },
    saveLocal() {
      if(typeof this.transactions == "object") {
        this.$root.localStorageStore.save(`global-pix-checkout:${this.partner_id}`, this.transactions)
      } else {
        this.$root.localStorageStore.save(`global-pix-checkout:${this.partner_id}`, [])
      }
    },
    loadLocal() {
      let transactions = this.$root.localStorageStore.load(`global-pix-checkout:${this.partner_id}`)
      if(transactions == null) {
        this.saveLocal([]);
        return [];
      }
      return transactions
    },
    createNewPixTransaction() {
      if (this.transactions.findIndex(el => el.new_payment == true) == -1){
        this.transactions.push({__ref__: uuidv4(), new_payment: true})
        this.saveLocal()
      }
    },
    onTransactionUpdated(transaction) {
      this.transactions = this.transactions.map(function(t){
        if(t.__ref__ == transaction.__ref__){
          return transaction
        } else {
          return t
        }
      })
      this.saveLocal()
    },
    onCloseTransaction(transaction) {
      this.transactions = this.transactions.filter(t => {
        return t.__ref__ !== transaction.__ref__
      })

      this.saveLocal()
    },
  },
  created() {
    this.transactions = this.loadLocal();
    if (this.transactions.length == 0){
      this.createNewPixTransaction()
    }
  },
  mounted() {
    const self = this;
    this.$root.authenticationStore.redirectIfNotAuthenticated()
    this.$root.store.connectSocket(this.$cookies.get('api_token'), {
      timeout: 10000,
      successCallback: function() { self.socketConnected = true},
      errorCallback: function() { self.socketConnected = false}
    })
    this.company_id = this.$cookies.get('company_id')
  },
  metaInfo: {
    title: "Facilita Pay"
  }
}
</script>

<style>
  .global-pix-box {
    transition: all 1s;
    position: relative;
    opacity: 1
  }
  .global-pix-box.disabled {
    opacity: 0.5
  }
  .box-socket-pending {
    position: absolute;
    z-index: 100;
    width: 100%;
    background: #FFF;
    text-align: center;
    padding: 15px;



  }
</style>



// WEBPACK FOOTER //
// src/pages/PixPaymentPage.vue